export const AUTH_COOKIE_NAME = "dpdauth";
export const AUTH_COOKIE_EXPIRATION = 1 * 60 * 60 * 1000; // 1 hour in millis
export const NOT_AUTHENTICATED_RESPONSE_STATUS_CODE = 401;
export const BYPASS_ENDPOINTS = ["/token/refresh"];

export const LS_ORDER_STORAGE = "dpd-order";
